export default __webpack_public_path__ + "static/media/noItem.230c37c9.svg";